export const TICKET_STATUSES = {
  PENDING_ASSIGNMENT: 'PENDING_ASSIGNMENT',
  ASSIGNED: 'ASSIGNED',
  WORK_IN_PROGRESS: 'WORK_IN_PROGRESS',
  PENDING: 'PENDING',
  OPEN: 'PENDING_ASSIGNMENT',
  IN_PROGRESS: 'WORK_IN_PROGRESS',
  REOPENED: 'REOPENED',
  ON_HOLD: 'ON_HOLD',
  REASSIGNED: 'REASSIGNED',
  CLOSED: 'CLOSED'
};

export const TICKET_PRIORITIES = {
  CRITICAL: 'CRITICAL',
  HIGH: 'HIGH',
  NORMAL: 'NORMAL',
  LOW: 'LOW'
};

export const TICKET_TYPES = {
  AMC: 'AMC',
  AMC_WARRANTY: 'AMC_WARRANTY',
  PM: 'PM',
  PM_WARRANTY: 'PM_WARRANTY'
};

// export const TYPES_REQUIRING_NO_SELECTION = [TICKET_TYPES.PM, TICKET_TYPES.PM_WARRANTY];
export const TYPES_REQUIRING_NO_SELECTION = [];

export const TICKET_TYPE_LABELS = {
  [TICKET_TYPES.AMC]: 'AMC Complaint Call',
  [TICKET_TYPES.PM]: 'PPM Activity',
  [TICKET_TYPES.AMC_WARRANTY]: 'PRJ Complaint Call',
  [TICKET_TYPES.PM_WARRANTY]: 'PRJ PPM Warranty'
};

export const CONTRACT_TYPES = {
  COMPREHENSIVE: 'Comprehensive',
  NON_COMPREHENSIVE: 'Non-Comprehensive',
  BOTH: 'Both'
};

export const STATUS_COLORS = {
  [TICKET_STATUSES.PENDING_ASSIGNMENT]: '#3b82f6',
  [TICKET_STATUSES.ASSIGNED]: '#8b5cf6',
  [TICKET_STATUSES.WORK_IN_PROGRESS]: '#f59e0b',
  [TICKET_STATUSES.PENDING]: '#f97316',
  [TICKET_STATUSES.REOPENED]: '#ef4444',
  [TICKET_STATUSES.REASSIGNED]: '#6366f1',
  [TICKET_STATUSES.ON_HOLD]: '#6b7280',
  [TICKET_STATUSES.CLOSED]: '#059669'
};

export const PRIORITY_COLORS = {
  [TICKET_PRIORITIES.CRITICAL]: '#dc2626',
  [TICKET_PRIORITIES.HIGH]: '#f59e0b',
  [TICKET_PRIORITIES.NORMAL]: '#3b82f6',
  [TICKET_PRIORITIES.LOW]: '#6b7280'
};

export const CONTRACT_STATUSES = {
  ACTIVE: 'Active',
  NEAR_EXPIRY: 'Near Expiry',
  EXPIRED: 'Expired'
};

export const getContractStatus = (contract) => {
  if (!contract) return CONTRACT_STATUSES.EXPIRED;
  if (contract.status) return contract.status;
  if (contract.expired || !contract.is_enabled) {
    return CONTRACT_STATUSES.EXPIRED;
  }
  const endDate = new Date(contract.end_date);
  const now = new Date();
  if (endDate < now) {
    return CONTRACT_STATUSES.EXPIRED;
  }
  const diffTime = endDate - now;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  if (diffDays <= 30) {
    return CONTRACT_STATUSES.NEAR_EXPIRY;
  }
  return CONTRACT_STATUSES.ACTIVE;
};